module.exports = "/build/web/svg/article-type-text.e80a534f28e34c034020616253fd5808.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/article-type-text.svg
// module id = 145
// module chunks = 24